import React, {Component} from 'react';
import {Hint, HorizontalGridLines, VerticalBarSeries as BarSeries, VerticalGridLines, XAxis, XYPlot, YAxis,} from "react-vis/es/index";
import DateAndTimeFormat from "../../../../utilities/DateAndTimeFormat";
import moment from "moment";


class RaportZapelnieniaWykres extends Component {

    state = {
        ilevalue: null
    }

    _forgetValue = (typ) => {
        if (typ === 'ile') this.setState({ilevalue: null});
        else this.setState({wartvalue: null});
    }

    _rememberValue = (value, typ) => {
        if (typ === 'ile') this.setState({ilevalue: value});
        else this.setState({wartvalue: value});

    }

    renderHint = (obj) => {
        return (
            <div className="CHARTtooltip">
                <span className="tooltiptext">
                    {
                        obj.datar ?
                            <div><div>Data: {obj.datar} </div><div>{this.getDayOfWeek(obj.datar)}</div></div>
                            :
                            <div>Godzina: {DateAndTimeFormat.formatHHMM(obj.godz1p)}</div>
                    }
                    <div>Ile jednorazowych: {obj.ilejednorazowe}</div>
                <div>Ile odbić mies.: {obj.ileodbic}</div>
                    <div>
                        Suma: {obj.ilejednorazowe + obj.ileodbic}
                    </div>
                </span>
            </div>
        )
    }

    getDayOfWeek=(date)=>{
       return moment(date).format('dddd')

    }

    render() {
        let {data} = this.props;

        const kolorJednorazowe = 'darkorange';
        const kolorOdbicia = '#a83da7';

        return (
            <div>
                <div>
                    <div className={'pull-right'}>
                        Legenda:
                        <span className={'label label-ebus-primary'} style={{background: kolorJednorazowe, margin: "0 5px"}}>Bilety jednorazowe</span>
                        <span className={'label label-ebus-primary'} style={{background: kolorOdbicia}}>Odbicia miesięczne</span>
                    </div>
                </div>
                <div>
                    <XYPlot
                        width={1600}
                        height={500}
                        stackBy={'y'}
                        xType={'ordinal'}
                        margin={{top: 25, bottom: 100}}
                    >
                        <VerticalGridLines/>
                        <HorizontalGridLines/>
                        <XAxis tickLabelAngle={-90}/>
                        <YAxis title={'Ilość'}/>
                        {this.state.ilevalue ? <Hint value={this.state.ilevalue}>{this.renderHint(this.state.ilevalue)}</Hint> : null}
                        <BarSeries
                            data={Array.from(data, item => (
                                {
                                    ...item,
                                    y: item.ilejednorazowe,
                                    x: (item.datar) ? item.datar : DateAndTimeFormat.formatHHMM(item.godz1p)
                                }
                            ))}
                            color={kolorJednorazowe}
                            onValueMouseOver={(val) => this._rememberValue(val, 'ile')}
                            onValueMouseOut={() => this._forgetValue('ile')}
                        />
                        <BarSeries
                            data={Array.from(data, item => (
                                {
                                    ...item,
                                    y: item.ileodbic,
                                    x: (item.datar) ? item.datar : DateAndTimeFormat.formatHHMM(item.godz1p)
                                }
                            ))}
                            color={kolorOdbicia}
                            onValueMouseOver={(val) => this._rememberValue(val, 'ile')}
                            onValueMouseOut={() => this._forgetValue('ile')}
                        />
                    </XYPlot>
                </div>
            </div>
        );
    }
}

export default RaportZapelnieniaWykres;


// WEBPACK FOOTER //
// ./src/modules/raporty/RaportZapelnienia/components/RaportZapelnieniaWykres.js